import { AfterViewInit, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { IWizItemRenderer, WizBaseCollector } from '@wizeoo/akm-component-lib';

/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'freedata-timeline-event-renderer',
  templateUrl: './freedata-timeline-event.renderer.html',
})
export class FreedataTimelineEventRenderer implements AfterViewInit, IWizItemRenderer<null, any> {
  
  constructor(private cdref: ChangeDetectorRef, public elementRef: ElementRef) {}
  data: any;
  owner: WizBaseCollector;

  public getColor(): string {
    return this.data.extendedProps.color;
  }

  public get fullStr(): string { 
    return this.data.extendedProps.content;
  }

  public get contentStr(): string {
    return this.data.extendedProps.title;
  }



  // TODO passer par les formats
  ngAfterViewInit() {

  }


}
